// extracted by mini-css-extract-plugin
export default {"form":"PersonalDetails_form__1SjJK","fieldGroup":"PersonalDetails_fieldGroup__-G3X3","button":"PersonalDetails_button__oB8+B"};